module.exports = __webpack_public_path__ + "img/10mmzuantao1.prt.5db91c24.jpg";